<template>
  <section class="accordion" :class="{ 'accordion--active': isOpen }">
    <button class="accordion__header" @click="toggle($event)">
      <div class="accordion__trigger-inner">
        <slot name="header"></slot>
        <div v-if="showIndicatorIcon && hasContent" style="padding-left: 20px">
          <div
            class="accordion__trigger-caret"
            :style="transitionDurationStyle"
            :class="{ 'accordion__trigger-caret--active': isOpen }"
          >
            <i class="mdi mdi-chevron-down fa-2x"></i>
          </div>
        </div>
      </div>
    </button>
    <div v-if="hasContent">
      <transition
        @enter="onEnter"
        @after-enter="onAfterEnter"
        @before-leave="onBeforeLeave"
        @leave="onLeave"
      >
        <div
          v-if="isOpen"
          ref="wrapper"
          class="accordion__content"
          :style="transitionDurationStyle"
        >
          <div ref="inner" class="accordion__content--inner">
            <slot name="content"></slot>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    showIndicatorIcon: {
      type: Boolean,
      default: true,
      required: false,
    },
    transitionDuration: {
      default: 250,
      required: false,
      type: Number,
    },
    openByDefault: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    hasContent() {
      return this.$slots.content;
    },
    transitionDurationStyle() {
      return {
        transitionDuration: `${this.transitionDuration}ms`,
        animationDuration: `${this.transitionDuration}ms`,
      };
    },
  },
  mounted() {
    if (this.openByDefault) {
      this.isOpen = true;
      this.setWrapperHeightTo('auto');
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    onEnter(el) {
      this.setWrapperHeightTo(this.getContentHeight(), el);
    },
    onAfterEnter(el) {
      this.setWrapperHeightTo('auto', el);
    },
    onBeforeLeave(el) {
      this.setWrapperHeightTo(this.getContentHeight(), el);
    },
    onLeave(el) {
      // eslint-disable-next-line no-unused-expressions
      el.scrollHeight;
      this.setWrapperHeightTo(0, el);
    },
    getContentHeight() {
      const { inner } = this.$refs;
      return inner.getBoundingClientRect().height;
    },
    /**
     * @param {number | 'auto'} height
     */
    setWrapperHeightTo(height, el = this.$refs.wrapper) {
      if (!el) return;
      // eslint-disable-next-line no-param-reassign
      el.style.height = typeof height === 'number' ? `${height}px` : height;
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "~@/assets/css/sass/bootstrap/_variables.scss";
$accordion-caret-transform: rotate(0deg);
$accordion-caret-transforming: rotate(-90deg);
$accordion-caret-active-transform: rotate(-180deg);
.accordion {
  font-size: inherit;
  background: white;
  box-shadow: 0 2px 5px 0 #00000006, 0 1px 1px 0 transparent;
  border-radius: 6px;
  width: 100%;
  &:hover {
    box-shadow: 0 2px 5px 0 #00000010, 0 1px 1px 0 transparent;
    // border: 1px solid #e5e5e5;
  }
  &:focus {
    outline: none;
  }
  &__header {
    width: 100%;
    background: none;
    border: none;
    appearance: none;
    padding: 0;
  }
  &__trigger-inner {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__trigger-caret {
    transform: $accordion-caret-transform;
    animation: accordion-is-inactive 0s linear forwards;
    color: $gray-dark;
    height: 20px;
    line-height: 20px;
    &--active {
      animation: accordion-is-active 0s linear forwards;
    }
  }
  &__content {
    transition-timing-function: ease;
    transition-property: height;
    height: 0;
    overflow: hidden;
  }
  &__content--inner {
    padding: 25px 0;
    border-top: 1px solid gainsboro;
    margin: 0 25px;
  }
  @keyframes accordion-is-active {
    0% {
      transform: $accordion-caret-transform;
    }
    50% {
      transform: $accordion-caret-transforming;
    }
    100% {
      transform: $accordion-caret-active-transform;
    }
  }
  @keyframes accordion-is-inactive {
    0% {
      transform: $accordion-caret-active-transform;
    }
    50% {
      transform: $accordion-caret-transforming;
    }
    100% {
      transform: $accordion-caret-transform;
    }
  }
}
</style>
